import { render, staticRenderFns } from "./IeWarning.vue?vue&type=template&id=60456b03&scoped=true&"
import script from "./IeWarning.vue?vue&type=script&lang=js&"
export * from "./IeWarning.vue?vue&type=script&lang=js&"
import style0 from "./IeWarning.vue?vue&type=style&index=0&id=60456b03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60456b03",
  null
  
)

export default component.exports